import React from 'react'
import { GoogleLogin } from '@react-oauth/google';
import share from '../assets/share.mp4'
import logo from '../assets/logowhite.png'
import jwtdecode from 'jwt-decode'
import { client } from '../client';
import { useNavigate } from 'react-router-dom';
const Login = () => {
  // const [ProfileInfo, setProfileInfo] = useState({})
  const navigate =useNavigate()
  const handleResponse=(response)=>{
    const {name,sub,picture} = jwtdecode(response.credential)
    localStorage.setItem('user',JSON.stringify({name,sub,picture}))
    const doc = {
      _id:sub,
      _type:'user',
      userName:name,
      image:picture
    }
    client.createIfNotExists(doc)
    .then(()=>{
        navigate('/',{replace:true})
    })
    
  }
  return (
    <div className='h-screen flex justify-start items-center flex-col'>
    <div className='relative w-full h-full'>
         <video
         src={share}
         type="video/mp4"
         loop
         controls={false}
         muted
         autoPlay
         className='w-full h-full object-cover'
         />
         <div className='absolute flex flex-col items-center justify-center inset-0 bg-blackOverlay '>
                 <div className='p-5'>
                     <img src={logo} alt="logo" width={130} />
                 </div>
                 <div className='shadow-2xl'>
                 <GoogleLogin
 onSuccess={handleResponse}
 onError={() => {
     console.log('Login Failed');
 }}
 />

                 </div>
         </div>  
    </div>
 </div>
  )
}

export default Login